import React, { useState } from "react";
import { Drawer, Button } from "antd";
import AIAssistanceChat from "./AIAssistanceChat";

const ChatbotContainer = ({ coachId, clientId, status }) => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleChat = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <>
      {/* Floating Chatbot Button */}
      {/* <Button
        className="chat-ai-assistance-toggle-button p-2"
        onClick={toggleChat}
      >
        <div className="chat-bg d-flex flex-column align-items-center text-white p-1 rounded-4">
          <span
            style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)",
            }}
            className="fs-6 mt-2"
          >
            AI Assistance
          </span>
          <i
            className="bi bi-chat-left-text fs-4 mb-2"
            style={{ transform: "rotate(270deg)" }}
          ></i>
        </div>
      </Button> */}

      {/* Drawer (Chatbot Window) */}
      <Drawer
        placement="right"
        width={500}
        closable={false}
        mask={true}
        open={isVisible}
        onClose={toggleChat}
        className="chatbot-drawer"
        rootStyle={{ position: "fixed", zIndex: 2000 }}
        styles={{
          body: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            backgroundColor: "#fafafa",
          },
        }}
      >
        <AIAssistanceChat
          coachId={coachId}
          clientId={clientId}
          status={status}
        />
        {/* <div className="chatbot-header">
          <FaRobot className="me-2" /> FitBot Assistant
        </div>

        <div className="chatbot-body">
          {!selectedOption ? (
            <>
              <ChatMessage
                sender="bot"
                text="Please choose an option below:"
                icon="🤖"
              />
              <ChatOptions onOptionClick={handleOptionClick} />
            </>
          ) : selectedOption === "meal" ? (
            <ClientMealsDetails
              coachId={coachId}
              clientId={clientId}
              status={status}
              isVisible={false}
            />
          ) : (
            <ClientWorkoutPlan />
          )}
        </div> */}
      </Drawer>
    </>
  );
};

export default ChatbotContainer;
